import { api } from "./client";

export type Comparator = "gt" | "lt" | "gte" | "lte";
export type Metric = "concentration" | "trend_pct";

export interface AlertRule {
  id: number;
  pathogen_id: number | null;
  pathogen_name: string | null;
  metric: Metric;
  comparator: Comparator;
  threshold: number;
  is_paused: boolean;
  last_triggered_at: string | null;
  created_at: string;
}

export interface AlertRuleCreate {
  pathogen_id?: number | null;
  metric?: Metric;
  comparator: Comparator;
  threshold: number;
}

export interface AlertRuleUpdate {
  pathogen_id?: number | null;
  metric?: Metric;
  comparator?: Comparator;
  threshold?: number;
  is_paused?: boolean;
}

export const alertsApi = {
  list: (deviceId: string) =>
    api.get<{ rules: AlertRule[] }>(`/api/dashboard/devices/${deviceId}/alerts`),
  create: (deviceId: string, body: AlertRuleCreate) =>
    api.post<AlertRule>(`/api/dashboard/devices/${deviceId}/alerts`, body),
  update: (deviceId: string, ruleId: number, body: AlertRuleUpdate) =>
    api.patch<AlertRule>(`/api/dashboard/devices/${deviceId}/alerts/${ruleId}`, body),
  delete: (deviceId: string, ruleId: number) =>
    api.delete<void>(`/api/dashboard/devices/${deviceId}/alerts/${ruleId}`),
};
